
export const upTeeth = Object.freeze([
  ...Array(8).fill(0).map((i, x) => '1' + (8 - x)),
  ...Array(8).fill(0).map((i, x) => '2' + (1 + x)),
]);
export const loTeeth = Object.freeze([
  ...Array(8).fill(0).map((i, x) => '4' + (8 - x)),
  ...Array(8).fill(0).map((i, x) => '3' + (1 + x)),
]);

export const teeth = Object.freeze([...upTeeth, ...[...loTeeth].reverse()]);

export function indexOf(tooth) {
  if (tooth === 'min') return Number.MIN_SAFE_INTEGER;
  if (tooth === 'max') return Number.MAX_SAFE_INTEGER;
  const x = teeth.indexOf(tooth);
  return x === -1 ? Number.NaN : x;
}

export function distance(from, to) {
  return indexOf(to) - indexOf(from);
}

export function range(str) {
  if (str === 'upper') return upTeeth;
  if (str === 'lower') return loTeeth;
  if (Array.isArray(str)) return str.sort(asc);
  const [from, to = from] = str.split('-');
  return teeth.filter(x => distance(from, x) >= 0 && distance(x, to) >= 0);
}

function asc(a, b) {
  const ia = indexOf(a);
  const ib = indexOf(b);
  return ia < ib ? -1 : ia > ib ? 1 : 0;
}

export function merge(...ranges) {
  const combined = ranges.map(range).flat().sort(asc);
  return [... new Set(combined).values()];
}

export function intersect(a, b) {
  const aa = range(a);
  return range(b).filter(x => aa.indexOf(x) >= 0);
}

export function stringify(range) {
  if (!Array.isArray(range)) {
    return range;
  }
  throw new Error('Not implemented');
}
